import { Injectable } from '@angular/core';
import { ICampanaData } from '@core/interfaces/entidades/campana.entidad';
import {
  IActualizarEstadoCampanaReq,
  ICrearCampanaReq,
} from '@core/interfaces/request-response/campana.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class CampanaApiService extends BaseHttpService {
  crear(data: ICrearCampanaReq) {
    return this.withLoader(
      this.httpClient.post<ICampanaData>(
        `${environment.apiUrl}${environment.apiPreFix}/campana/v2/crear`,
        data,
      ),
    );
  }

  cargarActivas() {
    return this.withLoader(
      this.httpClient.get<ICampanaData[]>(
        `${environment.apiUrl}${environment.apiPreFix}/campana/v2/activas`,
      ),
    );
  }

  cambiarEstado(campanaId: number, data: IActualizarEstadoCampanaReq) {
    return this.withLoader(
      this.httpClient.put<ICampanaData>(
        `${environment.apiUrl}${environment.apiPreFix}/campana/v2/estado/${campanaId}`,
        data,
      ),
    );
  }
}
